import React from 'react';
import { Layers, FileText, CheckCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ProductOverview() {
  const badges = [{
    text: 'Principiante',
    color: 'bg-green-100 text-green-800 border-green-200',
    dot: 'bg-green-500'
  }, {
    text: 'Intermedio',
    color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    dot: 'bg-yellow-500'
  }, {
    text: 'Avanzado',
    color: 'bg-rose-100 text-rose-800 border-rose-200',
    dot: 'bg-rose-500'
  }, {
    text: 'Adultos Mayores',
    color: 'bg-purple-100 text-purple-800 border-purple-200',
    dot: 'bg-purple-500'
  }, {
    text: 'Planificación',
    color: 'bg-blue-100 text-blue-800 border-blue-200',
    dot: 'bg-blue-500'
  }, {
    text: 'Natatorio y Gimnasio',
    color: 'bg-aqua-100 text-aqua-800 border-aqua-200',
    dot: 'bg-aqua-500'
  }];
  const topics = ['Fundamentos', 'Nivel Inicial', 'Nivel Intermedio', 'Adultos Mayores', 'Coreografía', 'Gestión', 'Planificación', 'Técnica', 'Corrección', 'Seguridad', 'Evaluación', 'Progresión', 'Seguimiento', 'Música', 'Equipamiento'];
  return <section className="py-12 md:py-24 bg-deepblue-900 text-white relative overflow-hidden" data-id="element-293">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-aqua-500/20 blur-3xl" data-id="element-294"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-96 h-96 rounded-full bg-deepblue-500/20 blur-3xl" data-id="element-295"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-296">
        <FadeIn data-id="element-297">
          <div className="text-center mb-8 md:mb-16" data-id="element-298">
            <span className="text-aqua-400 font-bold tracking-wider uppercase text-xs md:text-sm mb-2 md:mb-4 block" data-id="element-299">
              Sistema N°1 para Instructores de Aquagym en Argentina
            </span>
            <h2 className="text-3xl md:text-6xl font-display font-black mb-3 md:mb-6" data-id="element-300">
              AQUAGYM RESUELTO™
            </h2>
            <div className="inline-block bg-aqua-600 text-white px-4 py-1.5 md:px-6 md:py-2 rounded-full font-bold text-base md:text-2xl shadow-lg shadow-aqua-600/30 mb-4 md:mb-8" data-id="element-301">
              MEGAPACK — SISTEMA COMPLETO
            </div>
            <p className="text-base md:text-2xl text-deepblue-200 font-medium" data-id="element-302">
              6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-8 mb-8 md:mb-16" data-id="element-303">
          <FadeIn delay={0.1} data-id="element-304">
            <div className="bg-deepblue-800/50 backdrop-blur-sm border border-deepblue-700 p-4 md:p-8 rounded-xl md:rounded-2xl flex flex-col md:flex-row items-center md:items-center gap-3 md:gap-6 text-center md:text-left" data-id="element-305">
              <div className="w-10 h-10 md:w-16 md:h-16 rounded-full bg-aqua-500/20 flex items-center justify-center flex-shrink-0" data-id="element-306">
                <FileText className="w-5 h-5 md:w-8 md:h-8 text-aqua-400" data-id="element-307" />
              </div>
              <div data-id="element-308">
                <div className="text-2xl md:text-4xl font-display font-black text-white mb-0.5 md:mb-1" data-id="element-309">
                  +300
                </div>
                <div className="text-deepblue-200 font-medium text-xs md:text-base" data-id="element-310">
                  páginas estructuradas
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-311">
            <div className="bg-deepblue-800/50 backdrop-blur-sm border border-deepblue-700 p-4 md:p-8 rounded-xl md:rounded-2xl flex flex-col md:flex-row items-center md:items-center gap-3 md:gap-6 text-center md:text-left" data-id="element-312">
              <div className="w-10 h-10 md:w-16 md:h-16 rounded-full bg-aqua-500/20 flex items-center justify-center flex-shrink-0" data-id="element-313">
                <Layers className="w-5 h-5 md:w-8 md:h-8 text-aqua-400" data-id="element-314" />
              </div>
              <div data-id="element-315">
                <div className="text-2xl md:text-4xl font-display font-black text-white mb-0.5 md:mb-1" data-id="element-316">
                  60+
                </div>
                <div className="text-deepblue-200 font-medium text-xs md:text-base" data-id="element-317">
                  clases listas para dar
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-318">
          <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-10 shadow-2xl text-slate-800" data-id="element-319">
            <h3 className="text-lg md:text-2xl font-display font-bold text-center mb-4 md:mb-8 text-deepblue-900" data-id="element-320">
              Funciona desde hoy mismo en tu pileta
            </h3>

            <div className="mb-5 md:mb-10" data-id="element-321">
              <h4 className="text-xs md:text-sm font-bold text-slate-400 uppercase tracking-wider mb-3 md:mb-4 text-center" data-id="element-322">
                Niveles y enfoques incluidos
              </h4>
              <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-323">
                {badges.map((badge, i) => <span key={i} className={`px-2.5 py-1 md:px-4 md:py-2 rounded-full border text-xs md:text-sm font-bold flex items-center gap-1.5 ${badge.color}`} data-id="element-324">
                    <span className={`w-1.5 h-1.5 md:w-2 md:h-2 rounded-full ${badge.dot}`} data-id="element-325"></span>
                    {badge.text}
                  </span>)}
              </div>
            </div>

            <div data-id="element-326">
              <h4 className="text-xs md:text-sm font-bold text-slate-400 uppercase tracking-wider mb-3 md:mb-4 text-center" data-id="element-327">
                Todo lo que vas a dominar
              </h4>
              <div className="flex flex-wrap justify-center gap-1.5 md:gap-2" data-id="element-328">
                {topics.map((topic, i) => <span key={i} className="px-2 py-1 md:px-3 md:py-1.5 bg-slate-100 text-slate-600 rounded-md md:rounded-lg text-xs md:text-sm font-medium flex items-center gap-1" data-id="element-329">
                    <CheckCircle className="w-3 h-3 md:w-3.5 md:h-3.5 text-aqua-500" data-id="element-330" />
                    {topic}
                  </span>)}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}